import { useDrag } from "react-dnd";
import { DriverItem, DriverItemProps } from "./DriverItem";

export function DraggableDriverItem({
  isReadOnly,
  driver,
  roster,
  selectedDate,
  assigned,
  style,
  saveComment,
  saveShift,
}: DriverItemProps) {
  const [dragStyle, drag] = useDrag(
    () => ({
      type: `driver-shift-${driver.shift_type || 1}`,
      item: driver,
      collect: (monitor) => ({
        opacity: monitor.isDragging() ? 0.4 : 1,
      }),
    }),
    [driver]
  );

  return (
    <DriverItem
      isReadOnly={isReadOnly}
      driver={driver}
      roster={roster}
      selectedDate={selectedDate}
      assigned={assigned}
      ref={drag}
      style={{ ...style, ...dragStyle }}
      saveComment={saveComment}
      saveShift={saveShift}
    />
  );
}
